'use client';

import { useEffect } from 'react';
import { initFaroClient } from '@/lib/faro-client';

export default function FrontendObservability() {
  useEffect(() => {
    initFaroClient();
  }, []);

  return null;
}
